import React from 'react'

const DoubleEnteryAccounting = () => {
  return (
    <div>DoubleEnteryAccounting</div>
  )
}

export default DoubleEnteryAccounting